import { escapeHtml, getAvatarUrl } from '../../utils/helpers';

export default class ProfileView {
  constructor() {
    this.eventHandlers = {};
    this.currentTab = 'account';
  }

  async render() {
    return `
      <div id="page-profile" class="page-content active">
          <div class="profile-tabs" role="tablist" aria-label="Tab profil">
              <button class="profile-tab active" data-tab="account" data-text_tip="Pengaturan akun" data-hover_tip="bottom" data-dev_tip="desktop" role="tab" aria-selected="true" aria-controls="panel-account">Akun</button>
              <button class="profile-tab" data-tab="appearance" data-text_tip="Pengaturan tampilan" data-hover_tip="bottom" data-dev_tip="desktop" role="tab" aria-selected="false" aria-controls="panel-appearance">Tampilan</button>
              <button class="profile-tab" data-tab="notifications" data-text_tip="Pengaturan notifikasi" data-hover_tip="bottom" data-dev_tip="desktop" role="tab" aria-selected="false" aria-controls="panel-notifications">Notifikasi</button>
          </div>

          <div class="profile-panel active" id="panel-account" role="tabpanel" aria-labelledby="account-tab">
              
          </div>

          <div class="profile-panel" id="panel-appearance" role="tabpanel" aria-labelledby="appearance-tab">
              <div class="setting-group">
                  <h3>Mode Tema</h3>
                  <div class="setting-options" role="radiogroup" aria-labelledby="profile-theme-label">
                      <span id="profile-theme-label" class="sr-only">Pilih tema aplikasi</span>
                      <div class="setting-option active" data-theme="light" data-text_tip="Mode Terang" data-hover_tip="bottom" data-dev_tip="desktop" role="radio" aria-checked="true" tabindex="0">
                          <span class="material-symbols-rounded" aria-hidden="true">light_mode</span>
                          <span>Terang</span>
                      </div>
                      <div class="setting-option" data-theme="dark" data-text_tip="Mode Gelap" data-hover_tip="bottom" data-dev_tip="desktop" role="radio" aria-checked="false" tabindex="-1">
                          <span class="material-symbols-rounded" aria-hidden="true">dark_mode</span>
                          <span>Gelap</span>
                      </div>
                  </div>
              </div>
              <div class="setting-group">
                  <h3>Font Aplikasi</h3>
                  <div class="setting-options" role="radiogroup" aria-labelledby="profile-font-label">
                      <span id="profile-font-label" class="sr-only">Pilih font aplikasi</span>
                      <div class="setting-option normal-font active" data-font="default" data-text_tip="Font standar" data-hover_tip="bottom" data-dev_tip="desktop" role="radio" aria-checked="true" tabindex="0">
                          <span style="font-size: 1.5rem;" aria-hidden="true">Aa</span>
                          <span>Bawaan</span>
                      </div>
                      <div class="setting-option disleksia" data-font="disleksia" data-text_tip="Font ramah disleksia" data-hover_tip="bottom" data-dev_tip="desktop" role="radio" aria-checked="false" tabindex="-1">
                          <span style="font-size: 1.5rem;" aria-hidden="true">Aa</span>
                          <span>Ramah Disleksia</span>
                      </div>
                  </div>
              </div>
          </div>

          <div class="profile-panel" id="panel-notifications" role="tabpanel" aria-labelledby="notifications-tab">
              <div class="setting-group">
                  <h3>Notifikasi Push</h3>
                  <button type="button" id="enable-notifications-profile" class="post-submit" data-text_tip="Aktifkan notifikasi push" data-hover_tip="bottom" data-dev_tip="desktop">
                      <span class="material-symbols-rounded" aria-hidden="true">notifications_active</span>
                      <span>Aktifkan Notifikasi</span>
                  </button>
              </div>
          </div>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  setupTabEventListeners(onTabSwitch) {
    this.eventHandlers.tabHandlers = [];
    
    const tabs = this.getAllTabs();
    tabs.forEach(tab => {
      const handler = (e) => {
        const tabName = e.currentTarget.dataset.tab;
        onTabSwitch(tabName);
      };
      tab.addEventListener('click', handler);
      this.eventHandlers.tabHandlers.push({ element: tab, handler });
    });
  }

  setupThemeEventListeners(onThemeChange) {
    this.eventHandlers.themeHandlers = [];
    
    const themeButtons = this.getAllThemeButtons();
    themeButtons.forEach(btn => {
      const handler = (e) => {
        const theme = e.currentTarget.dataset.theme;
        if (theme) onThemeChange(theme);
      };
      btn.addEventListener('click', handler);
      this.eventHandlers.themeHandlers.push({ element: btn, handler });
    });
  }

  setupFontEventListeners(onFontChange) {
    this.eventHandlers.fontHandlers = [];
    
    const fontButtons = this.getAllFontButtons();
    fontButtons.forEach(btn => {
      const handler = (e) => {
        const font = e.currentTarget.dataset.font;
        if (font) onFontChange(font);
      };
      btn.addEventListener('click', handler);
      this.eventHandlers.fontHandlers.push({ element: btn, handler });
    });
  }

  setupLogoutEventListener(onLogout) {
    this.eventHandlers.logoutHandler = onLogout;
    
    // Event delegation untuk logout button yang bisa berubah-ubah
    this.eventHandlers.delegatedLogoutHandler = (e) => {
      if (e.target.closest('#logout-btn')) {
        e.preventDefault();
        this.eventHandlers.logoutHandler();
      }
    };
    
    const accountPanel = this.getAccountPanel();
    if (accountPanel) {
      accountPanel.addEventListener('click', this.eventHandlers.delegatedLogoutHandler);
    }
  }

  setupNotificationEventListener(onToggleNotifications) {
    const button = this.getNotificationButton();
    if (button) {
      this.eventHandlers.notificationHandler = onToggleNotifications;
      button.addEventListener('click', this.eventHandlers.notificationHandler);
    }
  }

  switchTab(tabName) {
    const tabs = this.getAllTabs();
    const panels = this.getAllPanels();
    
    tabs.forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    
    panels.forEach(p => p.classList.remove('active'));
    
    const activeTab = this.getTabByName(tabName);
    const activePanel = this.getPanelByName(tabName);
    
    if (activeTab) {
      activeTab.classList.add('active');
      activeTab.setAttribute('aria-selected', 'true');
    }
    
    if (activePanel) {
      activePanel.classList.add('active');
    }
    
    this.currentTab = tabName;
  }

  renderAccountPanel(userData) {
    const panelAccount = this.getAccountPanel();
    if (!panelAccount) return;
    
    if (!userData.isAuthenticated) {
      panelAccount.innerHTML = `
        <div class="auth-required">
          <span class="material-symbols-rounded">login</span>
          <h3>Masuk untuk mengakses akun</h3>
          <p>Silakan masuk atau daftar untuk mengakses fitur profil</p>
          <button id="profile-login-btn" type="button" class="post-submit" aria-label="Masuk sekarang">
            <span class="material-symbols-rounded" aria-hidden="true">login</span>
            Masuk Sekarang
          </button>
        </div>
      `;
    } else {
      panelAccount.innerHTML = `
        <div class="profile-info">
          <div class="profile-avatar">
            <img src="${getAvatarUrl(userData.user.name || 'User')}" alt="Foto profil" width="120" height="120" loading="lazy">
          </div>
          <div class="profile-name">${escapeHtml(userData.user.name || 'User')}</div>
          <div class="profile-email">${escapeHtml(userData.user.email || '')}</div>
          <button type="button" id="logout-btn" class="logout-btn" data-text_tip="Keluar dari akun" data-hover_tip="bottom" data-dev_tip="desktop">
            <span class="material-symbols-rounded" aria-hidden="true">logout</span>
            <span>Keluar</span>
          </button>
        </div>
      `;
    }
  }

  setupLoginButtonEventListener(onNavigateToAuth) {
    this.eventHandlers.loginHandler = onNavigateToAuth;
    
    // Event delegation untuk login button
    this.eventHandlers.delegatedLoginHandler = (e) => {
      if (e.target.closest('#profile-login-btn')) {
        e.preventDefault();
        this.eventHandlers.loginHandler();
      }
    };
    
    const accountPanel = this.getAccountPanel();
    if (accountPanel) {
      accountPanel.addEventListener('click', this.eventHandlers.delegatedLoginHandler);
    }
  }

  updateThemeSettings(currentTheme) {
    const themeButtons = this.getAllThemeButtons();
    
    themeButtons.forEach(el => {
      el.classList.remove('active');
      el.setAttribute('aria-checked', 'false');
      el.setAttribute('tabindex', '-1');
    });
    
    const activeTheme = this.getThemeButtonByValue(currentTheme);
    if (activeTheme) {
      activeTheme.classList.add('active');
      activeTheme.setAttribute('aria-checked', 'true');
      activeTheme.setAttribute('tabindex', '0');
    }
  }

  updateFontSettings(currentFont) {
    const fontButtons = this.getAllFontButtons();
    
    fontButtons.forEach(el => {
      el.classList.remove('active');
      el.setAttribute('aria-checked', 'false');
      el.setAttribute('tabindex', '-1');
    });
    
    const activeFont = this.getFontButtonByValue(currentFont);
    if (activeFont) {
      activeFont.classList.add('active');
      activeFont.setAttribute('aria-checked', 'true');
      activeFont.setAttribute('tabindex', '0');
    }
  }

  updateNotificationButton(isSubscribed) {
    const button = this.getNotificationButton();
    if (!button) return;

    if (isSubscribed) {
      button.innerHTML = `
        <span class="material-symbols-rounded" aria-hidden="true">notifications_off</span>
        <span>Nonaktifkan Notifikasi</span>
      `;
      button.setAttribute('data-text_tip', 'Nonaktifkan notifikasi push');
    } else {
      button.innerHTML = `
        <span class="material-symbols-rounded" aria-hidden="true">notifications_active</span>
        <span>Aktifkan Notifikasi</span>
      `;
      button.setAttribute('data-text_tip', 'Aktifkan notifikasi push');
    }
  }

  // Helper methods untuk DOM queries
  getAllTabs() {
    return Array.from(document.querySelectorAll('.profile-tab') || []);
  }

  getAllPanels() {
    return Array.from(document.querySelectorAll('.profile-panel') || []);
  }

  getAllThemeButtons() {
    return Array.from(document.querySelectorAll('.setting-option[data-theme]') || []);
  }

  getAllFontButtons() {
    return Array.from(document.querySelectorAll('.setting-option[data-font]') || []);
  }

  getTabByName(tabName) {
    return document.querySelector(`.profile-tab[data-tab="${tabName}"]`);
  }

  getPanelByName(tabName) {
    return document.querySelector(`#panel-${tabName}`);
  }

  getThemeButtonByValue(theme) {
    return document.querySelector(`.setting-option[data-theme="${theme}"]`);
  }

  getFontButtonByValue(font) {
    return document.querySelector(`.setting-option[data-font="${font}"]`);
  }

  getAccountPanel() {
    return document.querySelector('#panel-account');
  }

  getNotificationButton() {
    return document.querySelector('#enable-notifications-profile');
  }

  cleanupEventListeners() {
    if (this.eventHandlers.tabHandlers) {
      this.eventHandlers.tabHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers.tabHandlers = [];
    }

    if (this.eventHandlers.themeHandlers) {
      this.eventHandlers.themeHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers.themeHandlers = [];
    }

    if (this.eventHandlers.fontHandlers) {
      this.eventHandlers.fontHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers.fontHandlers = [];
    }

    const notificationButton = this.getNotificationButton();
    if (notificationButton && this.eventHandlers.notificationHandler) {
      notificationButton.removeEventListener('click', this.eventHandlers.notificationHandler);
    }

    const accountPanel = this.getAccountPanel();
    if (accountPanel) {
      if (this.eventHandlers.delegatedLogoutHandler) {
        accountPanel.removeEventListener('click', this.eventHandlers.delegatedLogoutHandler);
      }
      if (this.eventHandlers.delegatedLoginHandler) {
        accountPanel.removeEventListener('click', this.eventHandlers.delegatedLoginHandler);
      }
    }

    this.eventHandlers = {};
  }

  cleanup() {
    this.cleanupEventListeners();
  }
}